__turbopack_context__.v({
  "carouselSection": "Carousel-module__bZhkpa__carouselSection",
  "carouselWrapper": "Carousel-module__bZhkpa__carouselWrapper",
  "edgeBlocker": "Carousel-module__bZhkpa__edgeBlocker",
  "endEdge": "Carousel-module__bZhkpa__endEdge",
  "hiddenEnd": "Carousel-module__bZhkpa__hiddenEnd",
  "hiddenLeft": "Carousel-module__bZhkpa__hiddenLeft",
  "hiddenStart": "Carousel-module__bZhkpa__hiddenStart",
  "horizontalScroll": "Carousel-module__bZhkpa__horizontalScroll",
  "rtl": "Carousel-module__bZhkpa__rtl",
  "scrollButton": "Carousel-module__bZhkpa__scrollButton",
  "scrollEnd": "Carousel-module__bZhkpa__scrollEnd",
  "scrollStart": "Carousel-module__bZhkpa__scrollStart",
  "sectionTitle": "Carousel-module__bZhkpa__sectionTitle",
  "showBlocker": "Carousel-module__bZhkpa__showBlocker",
  "startEdge": "Carousel-module__bZhkpa__startEdge",
});
